import { SITE } from "@/content/site";

/** Shared Article JSON-LD fragments so English and Bangla posts expose the same entity. */

const JOB_TITLE = "SEO Expert & Digital Marketing Consultant";

/** Author entity for every article. */
export function articleAuthor() {
  return {
    "@type": "Person",
    "@id": `${SITE.url}/#person`,
    name: SITE.fullName,
    url: `${SITE.url}/about`,
    jobTitle: JOB_TITLE,
    sameAs: Object.values(SITE.social),
  };
}

/** Reviewer entity (the author reviews his own guides). */
export function articleReviewer() {
  return {
    "@type": "Person",
    "@id": `${SITE.url}/#person`,
    name: SITE.fullName,
    url: `${SITE.url}/about`,
    jobTitle: JOB_TITLE,
  };
}

/** Publisher organization for every article. */
export function articlePublisher() {
  return {
    "@type": "Organization",
    name: SITE.name,
    url: SITE.url,
    logo: { "@type": "ImageObject", url: `${SITE.url}/og-image.jpg` },
  };
}
